import React, {useState} from 'react';
import PropTypes from 'prop-types';
import ActionConfirmButton from './ActionConfirmButton';
import {useConfirm} from 'material-ui-confirm';
import {useManageConfirmMutation} from '../../../../api/services/profilesService';
import AdmicityDialog from '../../../../shared-components/AdmicityDialog';
import Box from '@mui/material/Box';

const ConfirmationWrapper = (
    {
        children,
        readonly,
        confirmData,
        hideActions = false,
        additionalActions = null
    }) => {
    const [openValidationDialog, setOpenValidationDialog] = useState(false);
    const [validationResult, setValidationResult] = useState(null);
    const confirm = useConfirm();
    const [manageConfirm] = useManageConfirmMutation();

    const handleSave = async () => {
        if (confirmData.preValidate) {
            const validationResult = confirmData.preValidate();

            if (!validationResult.isValid) {
                setValidationResult(validationResult.error);
                setOpenValidationDialog(true);

                return;
            }
        }

        confirm({
            title: 'Confirmation',
            confirmationText: 'Confirm',
            description: confirmData.confirmMessage,
        })
            .then(async () => {
                if (confirmData.preValidate) {
                    const validationResult = confirmData.preValidate();

                    setValidationResult(validationResult.error);

                    if (!validationResult.isValid) {
                        return;
                    }
                }

                await confirmData.handleSave(confirmData?.type);
                if (confirmData.confirmOnSave) {
                    await manageConfirm({
                        studentId: confirmData.studentId,
                        type: confirmData.type
                    });
                }
                await confirmData?.onConfirmSuccess();
            })
            .catch(() => {
            });
    };

    const handleConfirm = () => {
        if (confirmData.preValidate) {
            const validationResult = confirmData.preValidate();

            if (!validationResult.isValid) {
                setValidationResult(validationResult.error);
                setOpenValidationDialog(true);

                return;
            }
        }

        return confirm({
            title: 'Confirmation',
            confirmationText: 'Confirm',
            description: confirmData.confirmMessage,
        })
            .then(async () => {
                await manageConfirm({
                    studentId: confirmData.studentId,
                    type: confirmData.type
                });
                await confirmData?.onConfirmSuccess();
            })
            .catch(() => {
            });
    };

    return (
        <Box width="100%">
            {children}
            {
                hideActions
                    ? null
                    : <ActionConfirmButton
                        readonly={readonly}
                        confirmedAt={confirmData?.confirmedAt}
                        confirmedBy={confirmData?.confirmedBy}
                        onConfirm={handleConfirm}
                        onSave={handleSave}
                        enableSaveButton={confirmData.enableSaveButton}
                        enableConfirmButton={confirmData.enableConfirmButton}
                        confirmButtonText={confirmData.confirmButtonText}
                        additionalActions={additionalActions}
                    />
            }
            <AdmicityDialog
                handleClose={() => setOpenValidationDialog(false)}
                title={validationResult?.reason}
                open={openValidationDialog}
                actions={[
                    {label: 'Ok', onClick: () => setOpenValidationDialog(false)},
                ]}
            >
                {validationResult?.description}
            </AdmicityDialog>
        </Box>
    );
};

ConfirmationWrapper.propTypes = {
    readonly: PropTypes.bool,
    children: PropTypes.node.isRequired,
    confirmData: PropTypes.object.isRequired,
    hideActions: PropTypes.bool,
    additionalActions: PropTypes.node,
};

export default ConfirmationWrapper;
